module.exports = __webpack_public_path__ + "media/src/images/logos/mass-media/josh-c69f638b41eafcf86a5f0103aec5cbb4.png";